import Stream from '../libs/Stream';

export interface setWindowSizeAction {
  action: 'SET_WIDTH' | 'SET_HEIGHT';
  payload: number;
}

export let setWindowSizeActionStream: Stream<setWindowSizeAction> = new Stream() as Stream<setWindowSizeAction>;
